import MainLayout from '@/pages/Layout/MainLayout.vue'
const signature = () => import('@/pages/signature/Signature.vue')
const gsuOrdinances = () => import('@/pages/gsu/Ordinances.vue')
const gsuOrdinancesAdd = () => import('@/pages/gsu/components/CaseAddDataRequest.vue')
const gsuStat = () => import('@/pages/gsu/Stat.vue')



export default {
  path: '/',
  name: 'UCPage',
  component: MainLayout,
  children: [
    {
      path: 'signature',
      name: 'signature',
      component: signature,
      meta: {
        title: 'Документы на подпись',  
      }
    },
    {
      path: 'ordinances',
      name: 'gsuOrdinances',
      component: gsuOrdinances,
      meta: {
        title: 'Постановления',  
      }
    },
    {
      path: 'ordinances/add',
      name: 'gsuOrdinancesAdd',
      component: gsuOrdinancesAdd,
      meta: {
        title: 'Добавить постановление',
      }
    },
    {
      path: 'gsustat',
      name: 'gsuStat',
      component: gsuStat,
      meta: {
        title: 'Статистика',  
      }
    },
  ]
}